export const toPhaserLoaderUrl = (value: string): string =>
  value.startsWith('/assets/') ? value.slice(1) : value;
